<template>
  <!-- 单品方案设计 -->
  <div class="entMemInfo">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title"></page-header>
    <!-- 表单容器 -->
    <el-scrollbar style="width: 100%;height:calc(100% - 60px);padding-top:20px;box-sizing:border-box;">
      <el-form :model="addForm" label-position="right"
        label-width="100px" :rules="addFormRule" ref="addForm">
        <div class="form-item-wrap">
          <el-form-item label="客户名称" prop="name">
            <el-input readonly v-model="addForm.name" style="width: 200px;"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="客户性别" prop="sex">
            <el-input readonly v-model="addForm.sex" style="width: 200px;"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="联系电话" prop="tel">
            <el-input readonly v-model="addForm.tel" style="width: 200px;"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="会员生日" prop="birthday">
            <el-input readonly v-model="addForm.birthday" style="width: 200px;"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="会员积分" prop="integral">
            <el-input readonly v-model="addForm.integral" style="width: 200px;"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="注册日期" prop="registTime">
            <el-input readonly v-model="addForm.registTime" style="width: 200px;"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="客户状态" prop="status">
            <el-input readonly v-model="addForm.status" style="width: 200px;"></el-input>
          </el-form-item>
        </div>
        <!-- <div class="form-item-wrap">
          <el-form-item label="所属机构" prop="entName">
            <el-input readonly v-model="addForm.entName" style="width: 200px;"></el-input>
          </el-form-item>
        </div> -->
        <div class="form-item-wrap">
          <el-form-item label="单位名称" prop="business">
            <el-input readonly v-model="addForm.business" style="width: 200px;"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="经营范围" prop="range">
            <div style="width: 800px;">
              <div>
                <el-tag 
                  v-for="(item,index) in rangeList" 
                  :key="index" 
                  type="success"
                  effect="dark"
                  :disable-transitions="false"
                  class="my-el-tag"
                  style="margin-bottom: 5px;">{{item}}
                </el-tag>
              </div>
            </div>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="客户类型" prop="type">
            <el-input readonly v-model="addForm.type" style="width: 200px;"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="区域" prop="addressData">
            <el-input readonly v-model="addForm.addressData" style="width: 200px;"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="详细地址" prop="address">
            <el-input readonly v-model="addForm.address" style="width: 200px;"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="资格证书">
            <el-table
              :data="seniorityList"
              tooltip-effect="dark"
              style="width: 700px;border: 1px solid #EBEEF5;border-bottom: none;">
              <el-table-column
                label="序号"
                align="center"
                width="50">
                <template slot-scope="scope">
                  <span>{{scope.$index + 1}}</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                show-overflow-tooltip
                prop="name"
                label="名称">
              </el-table-column>
              <el-table-column
                align="center"
                show-overflow-tooltip
                prop="img"
                label="证书">
                <template slot-scope="scope">
                  <img-view :imgList="[{url:scope.row.img,id:0}]"></img-view>
                </template>
              </el-table-column>
              <el-table-column
                prop="validity"
                label="效期"
                align="center">
              </el-table-column>
            </el-table>
          </el-form-item>
        </div>
      </el-form>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  name: 'entMemInfo',
  data() {
    return {
      id: '',
      /**新增表单 */
      addForm:{
        name: "", // 名字
        userName: "", // 客户名称
        sex: "", // 客户性别
        tel: "", // 联系电话
        birthday: "", // 会员生日
        integral: "", // 会员积分
        registTime: "", // 注册日期
        status: "", // 客户状态
        pwd: "", // 密码
        entId: "", // 机构ID
        entName: "", // 所属机构
        business: "", // 所属单位
        range: "", // 经营范围
        type: "", // 客户类型
        addressData: "", // 区域
        address: "", // 地址
        validity: "", // 证书效期
      },
      /**表单规则 */
      addFormRule:{},
      rangeList: [],
      seniorityList: [],
      areaList: [],
      userList: [],
      ladderList: [
        {
          num: '',
          price: ''
        }
      ],
    }
  },
  mounted() {
    let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
    if(prams.id){
      this.id = prams.id
      this.getUserInfo()
    }
    this.getSeniority()
  },
  methods:{
    goBack() {
      this.$router.go(-1);
      this.$destroy()
    },
    // 获取客户详情
    getUserInfo(){
      let data = {
        type: "GetUserInfoDt",
        khId: this.id
      };
      let proc = "Proc_Admin_MembersQuery";//存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method:"post",
        url: "members/ashx/ReturnJson.ashx?type=" + type + "&json=" + encodeURIComponent(JSON.stringify(data)) + "&proc=" + proc,
      }).then((res) => {
        console.log(res);
        if (res.flag == 0) {
          let data = res.data[0]
          this.addForm.name = data.name
          this.addForm.useName = data.username
          this.addForm.sex = data.sex
          this.addForm.tel = data.telphone
          this.addForm.birthday = data.birthday
          this.addForm.integral = data.point
          this.addForm.registTime = data.add_time
          if(data.status == 1){
            this.addForm.status = '未审核'
          }else if(data.status == 2){
            this.addForm.status = '已审核'
          }else if(data.status == 0){
            this.addForm.status = '注销'
          }
          this.addForm.pwd = data.password
          this.addForm.entId = data.entid
          this.addForm.entName = data.entname
          this.addForm.business = data.businessname || data.businessname1
          this.addForm.range = this.$changeStr(data.businesscont)
          this.addForm.type = data.clienttype
          this.addForm.addressData = data.province + ' ' + data.city + ' ' + data.county
          this.addForm.address = data.address
          this.rangeList = this.$changeStrArr(data.businesscont)
        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      }).catch((err) => {
        window.console.log(err)
      });
    },
    // 获取资质列表
    getSeniority(){
      let data = {
        userId: this.id
      };
      this.$request({
        method: 'post',
        url: 'Member/GetMemberMaterial',
        data: data,
      }).then(res => {
        if(res.success){
          this.seniorityList = res.list.map(item => ({
            id: item.id,
            name: item.materialName,
            img: this.$setImgUrl(item.materialUrl),
            validity: item.valdate,
          }))
        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
  }
}
</script>

<style scoped>
.entMemInfo{
  width: 100%;
  height: 100%;
}
</style>